export const baseApiUrl = process.env.VUE_APP_BASE_API_URL
// export const baseApiUrl = 'http://localhost:4000'
